import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet';

export const PortalMenuSheet = ({ open, onOpenChange, items }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="bottom" className="rounded-t-3xl bg-[#0f2147] border-white/10 text-white pb-8" data-testid="portal-menu-sheet">
      <SheetHeader>
        <SheetTitle className="text-white text-left">Menu</SheetTitle>
      </SheetHeader>
      <div className="ep-grid-3 gap-3 mt-4">
        {items.filter(Boolean).map(({ key, label, icon: Icon, onClick, danger }) => (
          <button
            key={key}
            type="button"
            onClick={() => { onOpenChange(false); onClick(); }}
            data-testid={`menu-${key}`}
            className={`flex flex-col items-center gap-2 p-3 rounded-2xl border transition-colors ${danger ? 'border-red-400/40 bg-red-500/10 text-red-200' : 'border-white/10 bg-white/5 hover:bg-white/10'}`}
          >
            <Icon className="w-6 h-6" />
            <span className="ep-menu-label text-[11px] text-center leading-tight">{label}</span>
          </button>
        ))}
      </div>
    </SheetContent>
  </Sheet>
);
